<p-card styleClass="!shadow-none !h-full !w-full !border !border-[#dde1e6]">
  <div class="flex space-x-3 mx-auto shadow-none border-solid">
    <ng-container [ngTemplateOutlet]="getIconTemplate(icon())" />
    <div>
      <p
        class="text-[13px] xlplus:text-base text-taxpod-gray-light font-normal font-lato"
      >
        {{ content() }}
      </p>
      @if (isLoading()) {
      <p-skeleton width="20px" height="1.5rem"></p-skeleton>
      } @else {
      <p class="font-inter text-lg xlplus:text-xl font-bold">{{ count() }}</p>
      }
    </div>
  </div>
</p-card>

<ng-template #successIcon>
  <svg
    class="w-[35px] h-[35px] xlplus:w-[50px] xlplus:h-[50px]"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="25" cy="25" r="25" fill="#DFFBEF" />
    <path
      d="M32.3337 24.5417V20.4167L28.2087 15.8333H18.5837C18.0774 15.8333 17.667 16.2437 17.667 16.75V33.25C17.667 33.7563 18.0774 34.1667 18.5837 34.1667H24.0837"
      stroke="#1A8B57"
      stroke-width="2.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M25.917 31.4167L28.667 33.7084L32.792 28.6667"
      stroke="#1A8B57"
      stroke-width="2.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M27.75 15.8333V20.4167H32.3333"
      stroke="#1A8B57"
      stroke-width="2.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</ng-template>

<ng-template #failedIcon>
  <svg
    class="w-[35px] h-[35px] xlplus:w-[50px] xlplus:h-[50px]"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="25" cy="25" r="25" fill="#FFE7EA" />
    <path
      d="M32.3337 24.0417V19.9167L28.2087 15.3333H18.5837C18.0774 15.3333 17.667 15.7437 17.667 16.25V32.75C17.667 33.2563 18.0774 33.6667 18.5837 33.6667H24.0837"
      stroke="#E73A3A"
      stroke-width="2.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M27.292 27.25L32.792 32.75"
      stroke="#E73A3A"
      stroke-width="2.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M32.792 27.25L27.292 32.75"
      stroke="#E73A3A"
      stroke-width="2.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M27.75 15.3333V19.9167H32.3333"
      stroke="#E73A3A"
      stroke-width="2.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</ng-template>

<ng-template #reviewIcon>
 <svg 
    class="w-[35px] h-[35px] xlplus:w-[50px] xlplus:h-[50px]"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
  <circle cx="25" cy="25" r="25" fill="#FFF0CB" />
 <g transform="translate(16,13.5)">
    <path 
      fill-rule="evenodd" 
      clip-rule="evenodd" 
      d="M10.375 3.93704C10.375 4.30171 10.2301 4.65145 9.97227 4.90931C9.71441 5.16717 9.36467 5.31204 9 5.31204C8.63533 5.31204 8.28559 5.16717 8.02773 4.90931C7.76987 4.65145 7.625 4.30171 7.625 3.93704C7.625 3.57237 7.76987 3.22263 8.02773 2.96477C8.28559 2.70691 8.63533 2.56204 9 2.56204C9.36467 2.56204 9.71441 2.70691 9.97227 2.96477C10.2301 3.22263 10.375 3.57237 10.375 3.93704ZM12.3687 3.24954C12.211 2.47247 11.7894 1.77384 11.1754 1.27203C10.5615 0.770222 9.79293 0.496094 9 0.496094C8.20707 0.496094 7.43852 0.770222 6.82457 1.27203C6.21063 1.77384 5.78904 2.47247 5.63125 3.24954H2.125C1.76033 3.24954 1.41059 3.39441 1.15273 3.65227C0.894866 3.91013 0.75 4.25987 0.75 4.62454V21.1245C0.75 21.4892 0.894866 21.8389 1.15273 22.0968C1.41059 22.3547 1.76033 22.4995 2.125 22.4995H15.875C16.2397 22.4995 16.5894 22.3547 16.8473 22.0968C17.1051 21.8389 17.25 21.4892 17.25 21.1245V4.62454C17.25 4.25987 17.1051 3.91013 16.8473 3.65227C16.5894 3.39441 16.2397 3.24954 15.875 3.24954H12.3687ZM9 7.37454H5.5625V5.31204H2.8125V20.437H15.1875V5.31204H12.4375V7.37454H9ZM4.875 11.1558C4.875 10.8823 4.98365 10.62 5.17705 10.4266C5.37044 10.2332 5.63275 10.1245 5.90625 10.1245H12.0938C12.3673 10.1245 12.6296 10.2332 12.823 10.4266C13.0163 10.62 13.125 10.8823 13.125 11.1558C13.125 11.4293 13.0163 11.6916 12.823 11.885C12.6296 12.0784 12.3673 12.187 12.0938 12.187H5.90625C5.63275 12.187 5.37044 12.0784 5.17705 11.885C4.98365 11.6916 4.875 11.4293 4.875 11.1558ZM5.90625 13.562C5.63275 13.562 5.37044 13.6707 5.17705 13.8641C4.98365 14.0575 4.875 14.3198 4.875 14.5933C4.875 14.8668 4.98365 15.1291 5.17705 15.3225C5.37044 15.5159 5.63275 15.6245 5.90625 15.6245H12.0938C12.3673 15.6245 12.6296 15.5159 12.823 15.3225C13.0163 15.1291 13.125 14.8668 13.125 14.5933C13.125 14.3198 13.0163 14.0575 12.823 13.8641C12.6296 13.6707 12.3673 13.562 12.0938 13.562H5.90625Z" 
      fill="#998210"/>
  </g>
</svg>

</ng-template>



